import { memo } from 'react';

import {
    Box,
    Tooltip
} from '@mui/material';

import { useSocketStore } from '../stores/useSocketStore';

import useConnectionHealth from '../hooks/socket/useConnectionHealth';

// =========================
// CONFIG
// =========================

const QUALITY_CONFIG = {

    good: {
        color: 'success.main',
        label: 'Conexão boa'
    },

    medium: {
        color: 'warning.main',
        label: 'Conexão instável'
    },

    poor: {
        color: 'error.main',
        label: 'Conexão ruim'
    },

    offline: {
        color: 'text.disabled',
        label: 'Sem conexão'
    }

};

// =========================
// COMPONENT
// =========================

function ConnectionIndicator() {

    // =========================
    // MONITORAMENTO
    // =========================

    useConnectionHealth();

    // =========================
    // STORE
    // =========================

    const connectionQuality =
        useSocketStore(
            state =>
                state.connectionQuality
        );

    const connectionLatency =
        useSocketStore(
            state =>
                state.connectionLatency
        );

    // =========================
    // CONFIG
    // =========================

    const config =
        QUALITY_CONFIG[
            connectionQuality
        ] ||
        QUALITY_CONFIG.offline;

    // =========================
    // TOOLTIP
    // =========================

    const tooltip = connectionLatency
        ? (
            `${config.label} com o servidor • ` +
            `${connectionLatency} ms`
        )
        : config.label;

    // =========================
    // RENDER
    // =========================

    return (
        <Tooltip
            title={tooltip}
            arrow
        >
            <Box
                component="span"
                sx={{
                    position: 'absolute',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    display: 'inline-block',
                    width: 12,
                    height: 12,
                    borderRadius: '50%',
                    bgcolor: config.color,
                    cursor: 'default'
                }}
            />
        </Tooltip>
    );

}

export default memo(ConnectionIndicator);